import React, { useEffect, useContext, useState } from "react";
import "./../../../../font.css";
import { CircularProgress } from "@mui/material";
import { getLocale, I18n } from "react-i18nify";

import SocketIOContext from "./../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
// import SocketIOContext from "../../../contexts/Kiosk/SocketProvider/SocketIOContext";

let env = require("./../../../../env");

// Using a functional component, you must wrap it in React.forwardRef, and then forward the ref to
// the node you want to be the root of the print (usually the outer most node in the ComponentToPrint)
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-function-components
function SplashImage(props) {
  const { getKioskTheme } = useContext(SocketIOContext);
  const kioskTheme = getKioskTheme();

  return <I18n render={() => <SplashImageHelper kioskTheme={kioskTheme} />} />;
}

function SplashImageHelper(props) {
  const kioskTheme = props.kioskTheme;
  const [loadingFr, setLoadingFr] = useState(true);
  const [loadingEn, setLoadingEn] = useState(true);
  const locale = getLocale();
  const showEnglish = locale == "en";
  const showFrench = locale == "fr";

  return (
    <>
      <div
        id="EnSplashImage"
        style={{
          display: showEnglish ? "flex" : "none",
          height: "auto",
          width: "auto",
          maxWidth: "100%",
          maxHeight: "100%",
          justifyContent: "center"
        }}
      >
        {kioskTheme.HSplashEn && loadingEn ? (
          <div>
            <CircularProgress />
          </div>
        ) : (
          <></>
        )}

        <img
          src={
            env.REACT_APP_API_ENDPOINT +
            "/kiosk/getImage/HSplashEn" +
            "?t=" +
            kioskTheme.lastUpdatedImgETag
          }
          onLoad={() => setLoadingEn(false)}
          // objectFit="contain"
          style={{
            height: "auto",
            width: "auto",
            maxWidth: "100%",
            maxHeight: "100%"
          }}
          alt="Splash Image"
        />
      </div>
      <div
        id="FrSplashImage"
        style={{
          display: showFrench ? "flex" : "none",
          height: "auto",
          width: "auto",
          maxWidth: "100%",
          maxHeight: "100%",
          justifyContent: "center"
        }}
      >
        {kioskTheme.HSplashFr && loadingFr ? (
          <div>
            <CircularProgress />
          </div>
        ) : (
          <></>
        )}

        <img
          src={
            env.REACT_APP_API_ENDPOINT +
            "/kiosk/getImage/HSplashFr" +
            "?t=" +
            kioskTheme.lastUpdatedImgETag
          }
          onLoad={() => setLoadingFr(false)}
          // objectFit="contain"
          style={{
            height: "auto",
            width: "auto",
            maxWidth: "100%",
            maxHeight: "100%"
          }}
          alt="Splash Image"
        />
      </div>
    </>
  );
}

export default SplashImage;
